export const NotEligibleTitleHard = 'Deceased is not eligible';
export const NotEligibleTitleSoft = 'The deceased MAY NOT be eligible';
export const NotEligibleTitleNotAlberta = 'Deceased must be an Alberta resident';
export const PrescreenSuccessTitle = 'You\'re in the right place!';
export const MissingInformationTitle = 'Missing information';
export const IncludeProofOfDeniedTitle = 'Include proof of denied funding';
export const YouMayBeContactedTitle = 'You may be contacted';
export const CPPDeathBenefitDeductionTitle = 'CPP death benefit deduction';
export const PaymentResponsibilityTitle = 'Your payment responsibility';
export const FuneralServiceProviderLocationTitle = 'Funeral service providers location';
export const OfficeContactInformation = 'Office contact information';